<div style="vertical-align: top; margin: 20px;" valign="top">
  <h1 class="page-title">Zmiana hasła</h1>

  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <label class="label">Stare hasło</label>
      <input pInputText type="password" class="form-control" [(ngModel)]="model.oldPassword" />
    </div>

    <div class="ui-g-12">
      <label class="label">Nowe hasło</label>
      <input pInputText type="password" class="form-control" [(ngModel)]="model.password" />
    </div>

    <div class="ui-g-12">
      <label class="label">Powtórz hasło</label>
      <input pInputText type="password" class="form-control" [(ngModel)]="model.passwordConfirmation"/>
    </div>

    <div class="ui-g-12" style="text-align: right;">
      <span style="float: right;">
        <p-button type="button" (click)="changePassword()" label="Zapisz"></p-button>
      </span>
    </div>
  </div>
</div>
